// extracted by mini-css-extract-plugin
export default {"tableCard":"settings-table-card_tableCard__-t2nr"};